<div class="dialog-title" mat-dialog-title>
	<mat-dialog-content>
		<h2 class="disclosure--title">Disclosure</h2>
		<p class="tooltip--msrp">The Base Manufacturer's Suggested Retail Price (MSRP) is the price of the vehicle
			without the Documentation Fee,
			Destination / Delivery charge, Taxes, title and registration or optional equipment. The MSRP is the vehicle
			price as recommended by the “manufacturer” often called the ‘sticker’ or list price. Images shown may not
			necessarily represent the options selected on any vehicle.</p>
	</mat-dialog-content>

	<button aria-label="close dialog" mat-dialog-close mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>
</div>
